import mitt, { type EventType, type Emitter } from 'mitt';

// Define specific event types for the chat event bus
type ChatEvents = Record<EventType, unknown>

// Create a singleton event bus instance
let eventBus: Emitter<ChatEvents> | null = null;

export const useChatEventBus = (): Emitter<ChatEvents> => {
    if (!eventBus) {
        eventBus = mitt<ChatEvents>();
    }

    return eventBus;
};
